/* src/app/private/components/student/student-fees/student-fees.component.scss */
/*# sourceMappingURL=student-fees.component.css.map */
